/*
 *                     NOTICE
 *            COPYRIGHT 2019 Ab Initio
 *       UNPUBLISHED - ALL RIGHTS RESERVED
 *
 * This program is confidential and a trade secret of Ab Initio.
 * The receipt or possession of this program does not convey any
 * rights to reproduce or disclose its contents, or to manufacture,
 * use or sell anything that it may describe, in whole or in part,
 * without the specific written consent of Ab Initio.
 */

import { AbImage as AbImageImpl } from "abreact/misc/AbImage";
import * as React from "react";

/**
 * Properties of the AbImage component.
 */

/**
 * The **AbImage** component displays an image, which can optionally be dragged or clicked to perform an action.
 *
 * [[include:absdk/commons/ui/misc/AbImage.md]]
 */
export class AbImage extends React.Component {
  render() {
    return /*#__PURE__*/React.createElement(AbImageImpl, this.props);
  }
}
//# sourceMappingURL=AbImage.js.map
